import { z } from 'zod';

export const helpdeskEmailChannelSchema = z.object({
  id: z.uuid(),
  from: z.string().nullable(),
  available: z.boolean(),
  unavailableReason: z.string().nullable(),
});
export const helpdeskEmailDeliverySchema = z.object({
  id: z.uuid(),
  status: z.enum([
    'pending',
    'provider-accepted',
    'delivery-confirmed',
    'ambiguous',
    'failed',
    'bounced',
  ]),
  providerAcceptedAt: z.iso.datetime().nullable(),
  deliveryConfirmedAt: z.iso.datetime().nullable(),
  safeErrorCode: z.string().nullable(),
});
export type HelpdeskEmailChannel = z.infer<typeof helpdeskEmailChannelSchema>;
export type HelpdeskEmailDelivery = z.infer<typeof helpdeskEmailDeliverySchema>;
